exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.margin-top {\n    margin-top: 20px;\n}\n.doctor_list .el-select__input {\n    max-width: 100% !important;\n    margin: 0 10px !important;\n}\n.doctor_list .el-select__tags {\n    max-width: 100% !important;\n}\n.doctor_list .el-input__inner{\n    padding-right: 10px !important;\n    padding-left: 10px !important;\n    cursor: text !important;\n}\n.doctor_list .el-input__suffix {\n    display: none;\n}\n", ""]);

// exports
